// @flow
import { connect } from 'react-redux';
import Contact from '../components/Contact';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
  };
}

export default connect(mapStateToProps)(Contact);



// WEBPACK FOOTER //
// ./src/modules/contact/containers/ContactContainer.js